import ReactRenderer from "./modules/_react-renderer";
import PortConfigurator from "./modules/PortConfigurator";
import {PortOverviewStandalone} from "./modules/nassau-react/steps/PortOverviewStandalone";
import {FinalStepLeftStandalone} from "./modules/nassau-react/steps/FinalStepLeftStandalone";

ReactRenderer.registerComponent('PortConfigurator',PortConfigurator);
ReactRenderer.registerComponent('FinalStepLeftStandalone',FinalStepLeftStandalone);
ReactRenderer.registerComponent('PortOverviewStandalone',PortOverviewStandalone);
ReactRenderer.render();